// CANOA — "currently building" rotating phrase.
// Cycles through the items one at a time. Pauses entirely for visitors who
// prefer reduced motion (the first item stays visible), and pauses when the
// tab is hidden to avoid pointless work.
//
// Shared by the footer (hard-cut, Stack Sans) and the top-of-home ticker
// (soft fade) — the swap is identical; only the per-item CSS transition
// differs. Each rotator can override its item selector via
// data-item-selector; defaults to the footer's class.

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

function initRotator(root) {
  const selector = root.dataset.itemSelector || '.canoa-footer__rotator-item';
  const items = Array.from(root.querySelectorAll(selector));
  if (items.length < 2 || REDUCED_MOTION.matches) return;

  const interval = Math.max(1000, parseInt(root.dataset.interval, 10) || 3000);
  let index = items.findIndex((el) => el.classList.contains('is-active'));
  if (index < 0) index = 0;
  let timer = null;

  function show(next) {
    items[index].classList.remove('is-active');
    items[index].setAttribute('aria-hidden', 'true');
    index = next;
    items[index].classList.add('is-active');
    items[index].removeAttribute('aria-hidden');
  }

  function start() {
    if (timer) return;
    timer = window.setInterval(() => show((index + 1) % items.length), interval);
  }

  function stop() {
    window.clearInterval(timer);
    timer = null;
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  start();
}

document.querySelectorAll('[data-canoa-rotator]').forEach(initRotator);
